import React from 'react'
import { Link } from "gatsby"

import headerStyles from '../styles/headerblog.module.scss'
import '../styles/button.scss'
import Logo from './logoBlog'
import Menu from './menuBlog'
import Burger from'./burger'

const checkHeader = () => { 
    // Detect scroll position
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth > 1100) {
        let scrollPosition = Math.round(window.scrollY);

        if (scrollPosition > 100){
            document.querySelector('#nav').classList.add(`${headerStyles.sticky}`);
        }
        else {
            document.querySelector('#nav').classList.remove(`${headerStyles.sticky}`);
        }

    } else {

    }
};

// Check if window exists first
if (typeof window !== 'undefined') {
    // Run the checkHeader function every time you scroll
    window.addEventListener('scroll', checkHeader);
}




const Header = () => {

    return(

        
        <div className={headerStyles.nav} id='nav'>
            <div className={headerStyles.nav_logo}>
                <Link to='/'><Logo /></Link>
            </div>
            <Menu />
            <Burger />
        </div>
    )
}

export default Header